import React from 'react';

import { ActionButton } from 'app/components/Button/ActionButton';
import { FormInput } from 'app/components/Input/FormInput';
import ModalDefault from 'app/components/Modal/ModalDefault';

import { useFormik } from 'formik';
import * as Yup from 'yup';

interface RoomNameModalProps {
  onClickCloseModal: () => void;
  onSaveRoomName: (roomName: string) => void;
  selectedRoomName?: string;
  title?: string;
}

const RoomNameModal: React.FC<RoomNameModalProps> = ({
  onClickCloseModal,
  onSaveRoomName,
  selectedRoomName,
  title,
}) => {
  const formik = useFormik({
    initialValues: {
      roomName: selectedRoomName || '',
    },
    validationSchema: Yup.object({
      roomName: Yup.string().trim().required('Room name is required'),
    }),
    onSubmit: (values) => {
      onSaveRoomName(values.roomName);
      onClickCloseModal();
    },
  });

  return (
    <ModalDefault
      title={title || 'Room Name'}
      onClickCloseModal={onClickCloseModal}
      closeOnBackdrop={false}
      styleModalDialog={{ width: 500 }}
    >
      <form onSubmit={formik.handleSubmit}>
        <FormInput
          label={title || 'Room Name'}
          placeholder="Enter room name"
          formik={formik}
          field="roomName"
          isRequired
          rootClass="w-100 mb-4"
        />

        <ActionButton
          onCancel={onClickCloseModal}
          disableButton={formik.isSubmitting || !formik.isValid}
          isSubmitting={formik.isSubmitting}
          labelButtonSubmit="Save"
        />
      </form>
    </ModalDefault>
  );
};

export default RoomNameModal;
